// extracted by mini-css-extract-plugin
export default {"formTitle":"FormTitle_formTitle__tMRTO","formSubtitle":"FormTitle_formSubtitle__0Kja2"};